// Coarse, human relative time for a past instant. Precision drops with distance
// on purpose: nobody needs "43 days ago".
const MINUTE_MS = 60_000
const HOUR_MS = 60 * MINUTE_MS
const DAY_MS = 24 * HOUR_MS
const WEEK_MS = 7 * DAY_MS

export function formatRelativeTimestamp(
  iso: string,
  now: Date = new Date(),
): string {
  const date = new Date(iso)
  const ms = date.getTime()
  if (Number.isNaN(ms)) return ''
  const diff = now.getTime() - ms
  if (diff < MINUTE_MS) return 'just now'
  if (diff < HOUR_MS) {
    const mins = Math.floor(diff / MINUTE_MS)
    return `${mins} minute${mins === 1 ? '' : 's'} ago`
  }
  if (diff < DAY_MS) {
    const hours = Math.floor(diff / HOUR_MS)
    return `${hours} hour${hours === 1 ? '' : 's'} ago`
  }
  if (diff < WEEK_MS) {
    const days = Math.floor(diff / DAY_MS)
    if (days === 1) return 'yesterday'
    return `${days} days ago`
  }
  const weeks = Math.floor(diff / WEEK_MS)
  if (weeks < 5) {
    if (weeks === 1) return 'last week'
    return `${weeks} weeks ago`
  }
  const months = Math.floor(diff / (30 * DAY_MS))
  if (months < 12) {
    if (months === 1) return 'last month'
    return `${months} months ago`
  }
  const years = Math.floor(diff / (365 * DAY_MS))
  return `${years} year${years === 1 ? '' : 's'} ago`
}
